import { render, staticRenderFns } from "./ShiftTemplates.vue?vue&type=template&id=f4bd1c62&scoped=true"
import script from "./ShiftTemplates.vue?vue&type=script&lang=js"
export * from "./ShiftTemplates.vue?vue&type=script&lang=js"
import style0 from "./ShiftTemplates.vue?vue&type=style&index=0&id=f4bd1c62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4bd1c62",
  null
  
)

export default component.exports
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSpinner,QIcon,QItem,QItemSection,QCheckbox,QItemLabel});
